package pl.decks.chartjs.radar.options

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption

data class RadarScaleOptions(
    val display: Boolean = true,
    val min: Float? = null,
    val max: Float? = null,
    val suggestedMin: Float? = null,
    val suggestedMax: Float? = null,
    val beginAtZero: Boolean? = null,
    val startAngle: Float? = null,
    val backgroundColor: ChartColor? = null,
    val angleLines: AngleLineOptions? = null,
    val pointLabels: PointLabelOptions? = null,
    val ticks: TickOptions? = null,
    val grid: GridOptions? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.display = display.asDynamic()
        if (min != null) this.min = min.asDynamic()
        if (max != null) this.max = max.asDynamic()
        if (suggestedMin != null) this.suggestedMin = suggestedMin.asDynamic()
        if (suggestedMax != null) this.suggestedMax = suggestedMax.asDynamic()
        if (beginAtZero != null) this.beginAtZero = beginAtZero.asDynamic()
        if (backgroundColor != null) this.backgroundColor = backgroundColor.toChartJs()
        if (startAngle != null) this.startAngle = startAngle.asDynamic()
        if (angleLines != null) this.angleLines = angleLines.toChartJs()
        if (pointLabels != null) this.pointLabels = pointLabels.toChartJs()
        if (ticks != null) this.ticks = ticks.toChartJs()
        if (grid != null) this.grid = grid.toChartJs()
    }
}
